import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "../../assets/css/Testimonial.css";

const Testimonials = ({ testimonials, onTestimonialClick }) => {
    const testimonialRefs = useRef([]);

    useEffect(() => {
        const addTiltEffect = () => {
            testimonialRefs.current.forEach((card, index) => {
                if (card) {
                    card.addEventListener("mousemove", (event) => {
                        const cardRect = card.getBoundingClientRect();
                        const cardWidth = cardRect.width;
                        const cardHeight = cardRect.height;
                        const centerX = cardRect.left + cardWidth / 2;
                        const centerY = cardRect.top + cardHeight / 2;

                        const tiltX = ((event.clientY - centerY) / (cardHeight / 2)) * 15; // maxTilt: 15
                        const tiltY = ((event.clientX - centerX) / (cardWidth / 2)) * -15; // Reverse tilt for Y

                        card.style.transform = `perspective(1400px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.04)`;
                    });

                    card.addEventListener("mouseleave", () => {
                        card.style.transform = `perspective(1400px) scale(1)`;
                    });
                }
            });
        };

        addTiltEffect();

        return () => {
            testimonialRefs.current.forEach(card => {
                if (card) {
                    card.removeEventListener("mousemove", addTiltEffect);
                    card.removeEventListener("mouseleave", addTiltEffect);
                }
            });
        };
    }, []);

    return (
        <div className="swiper-container border-rounded mb-5">
            <Swiper
                loop={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: true,
                }}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                slidesPerView={3}
                spaceBetween={20}
                breakpoints={{
                    320: { slidesPerView: 1, spaceBetween: 50 },
                    768: { slidesPerView: 2, spaceBetween: 30 },
                    1024: { slidesPerView: 3, spaceBetween: 30 },
                }}
                modules={[Navigation, Autoplay]}
                className="swiper mb-6"
            >
                {testimonials.map((testimonial, index) => (
                    <SwiperSlide
                        key={index}
                        style={{
                            height: "250px"
                        }}
                        className="swiper-slide bg-black mb-5"
                        onClick={() => onTestimonialClick(testimonial)}
                    >
                        <div
                            className="testimonial my-0 d-flex flex-column gap-2 justify-content-center align-items-center"
                            ref={(el) => (testimonialRefs.current[index] = el)}
                        >
                            <img src={`https://api.glyphqai.com/uploads/testimonals/${testimonial.image}`} alt={testimonial.name} />
                            <h5 className="text-white m-0">{testimonial.title}</h5>
                            <p className="small">{testimonial.role}</p>
                            <p className="testimonial-detail d-none">{testimonial.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        </div>
    );
};

export default Testimonials;

